// Formatacao de data/hora no fuso do navegador.

export function hora(iso) {
  if (!iso) return '--:--'
  return new Date(iso).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
}

export function dataHora(iso) {
  if (!iso) return '—'
  return new Date(iso).toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

/** Papeis sao cumulativos: publicador ⊇ editor ⊇ leitor; admin cobre a cadeia. */
const NIVEL = { leitor: 1, editor: 2, publicador: 3 }

export function podeNoPapel(papelDoUsuario, papelExigido) {
  if (papelExigido === 'admin') return papelDoUsuario === 'admin'
  if (papelDoUsuario === 'admin') return true
  return (NIVEL[papelDoUsuario] ?? 0) >= (NIVEL[papelExigido] ?? 99)
}
